import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Text } from './styled';

const IconButton = ({
  onClick, title, icon, text, disabled, dataTestId
}) => (
  <Wrapper title={ title } onClick={ onClick } disabled={ disabled } data-testid={ dataTestId || undefined }>
    {icon}
    { text && <Text>{ text }</Text> }
  </Wrapper>
);

IconButton.defaultProps = {
  onClick: null,
  disabled: false,
  dataTestId: ''
};

IconButton.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  dataTestId: PropTypes.string
};

export default IconButton;
